import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

const Loading: React.FC<{ fullScreen?: boolean }> = ({ fullScreen = false }) => {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!fullScreen) return;
    const timer = window.setTimeout(() => setSlow(true), 7000);
    return () => window.clearTimeout(timer);
  }, [fullScreen]);

  return (
    <div role="status" className={`flex w-full flex-col items-center justify-center gap-3 ${fullScreen ? "min-h-screen bg-white px-5 text-center dark:bg-slate-950" : "min-h-[50vh]"}`}>
      <div className="relative grid h-24 w-24 place-items-center">
        <div className="absolute inset-0 animate-spin rounded-full border-4 border-primary-100 border-r-primary-400 border-t-primary-600 dark:border-slate-800 dark:border-r-primary-400 dark:border-t-primary-500" />
        <img src="/images/logo/smalllogo.png" alt="OnePlaceDeal" className="h-14 w-14 object-contain" />
      </div>
      {slow && fullScreen && <div className="max-w-sm text-sm text-slate-600 dark:text-slate-300"><p>Le chargement prend plus de temps que prévu. Vérifiez votre connexion.</p><button type="button" onClick={() => window.location.reload()} className="mt-3 inline-flex items-center gap-2 font-bold text-primary-700 dark:text-primary-300"><RefreshCw size={16} /> Recharger la page</button></div>}
    </div>
  );
};

export default Loading;
